import { render, staticRenderFns } from "./AdministrativePermitsPersonDaysCard.vue?vue&type=template&id=1f2838a1"
import script from "./AdministrativePermitsPersonDaysCard.vue?vue&type=script&lang=js"
export * from "./AdministrativePermitsPersonDaysCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports